<template>
  <v-card tile>
    <v-card-title class="grey lighten-2">
      Ärende
    </v-card-title>
    <OdocForm :locations="locations" :case-types="caseTypes" :readonly="true" />
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">Stäng</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import OdocForm from './form/OdocForm'
import { get } from 'vuex-pathify'

export default {
  name: 'OdocCreateModal',

  props: {
    locations: Array,
    caseTypes: Array
  },

  components: {
    OdocForm
  },

  data: () => ({
    valid: true,
    pending: false
  }),

  computed: {
    model: get('odoc/model')
  },

  methods: {
    closeModal() {
      this.$emit('close')
      this.$store.dispatch('odoc/resetModel')
    }
  }
}
</script>
